// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/icomoon.eot?o38exq", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/icomoon.ttf?o38exq", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/icomoon.woff?o38exq", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/icomoon.svg?o38exq", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./fonts/new-icons/icomoon-new.eot?qk2crm", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./fonts/new-icons/icomoon-new.ttf?qk2crm", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./fonts/new-icons/icomoon-new.woff?qk2crm", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./fonts/new-icons/icomoon-new.svg?qk2crm", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./fonts/chart-icons/icomoon.eot?hqjcbq", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./fonts/chart-icons/icomoon.ttf?hqjcbq", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./fonts/chart-icons/icomoon.woff?hqjcbq", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./fonts/chart-icons/icomoon.svg?hqjcbq", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./fonts/close-icons/icomoon.eot?7x7j5y", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./fonts/close-icons/icomoon.ttf?7x7j5y", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./fonts/close-icons/icomoon.woff?7x7j5y", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("./fonts/close-icons/icomoon.svg?7x7j5y", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("./fonts/help-icons/icomoon.eot?la35ux", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("./fonts/help-icons/icomoon.ttf?la35ux", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("./fonts/help-icons/icomoon.woff?la35ux", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("./fonts/help-icons/icomoon.svg?la35ux", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("./fonts/alert-icons/icomoon.eot?98yb9f", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("./fonts/alert-icons/icomoon.ttf?98yb9f", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("./fonts/alert-icons/icomoon.woff?98yb9f", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("./fonts/alert-icons/icomoon.svg?98yb9f", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("./fonts/export-icons/icomoon.eot?dbdzzi", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("./fonts/export-icons/icomoon.ttf?dbdzzi", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("./fonts/export-icons/icomoon.woff?dbdzzi", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("./fonts/export-icons/icomoon.svg?dbdzzi", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("./fonts/customize-icons/icomoon.eot?h20uxn", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("./fonts/customize-icons/icomoon.ttf?h20uxn", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("./fonts/customize-icons/icomoon.woff?h20uxn", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("./fonts/customize-icons/icomoon.svg?h20uxn", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("./fonts/bar-icons/icomoon.eot?3qba93", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("./fonts/bar-icons/icomoon.ttf?3qba93", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("./fonts/bar-icons/icomoon.woff?3qba93", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("./fonts/bar-icons/icomoon.svg?3qba93", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("./fonts/double-arrow-icons/icomoon.eot?7lkkx", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("./fonts/double-arrow-icons/icomoon.ttf?7lkkx", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("./fonts/double-arrow-icons/icomoon.woff?7lkkx", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("./fonts/double-arrow-icons/icomoon.svg?7lkkx", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("./fonts/staking-risk/icomoon.eot?tcjqyc", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("./fonts/staking-risk/icomoon.ttf?tcjqyc", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("./fonts/staking-risk/icomoon.woff?tcjqyc", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("./fonts/staking-risk/icomoon.svg?tcjqyc", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("./fonts/infoField/icomoon.eot?pvfjwx", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("./fonts/infoField/icomoon.ttf?pvfjwx", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("./fonts/infoField/icomoon.woff?pvfjwx", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("./fonts/infoField/icomoon.svg?pvfjwx", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("./fonts/statistics-icons/icomoon.eot?myhb3s", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("./fonts/statistics-icons/icomoon.ttf?myhb3s", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("./fonts/statistics-icons/icomoon.woff?myhb3s", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("./fonts/statistics-icons/icomoon.svg?myhb3s", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#icomoon" });
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___, { hash: "#icomoon" });
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___, { hash: "#icomoon" });
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "#icomoon" });
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___, { hash: "#icomoon" });
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___, { hash: "#icomoon" });
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___, { hash: "#icomoon" });
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___, { hash: "#icomoon" });
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___, { hash: "#icomoon" });
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___, { hash: "#icomoon" });
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___, { hash: "#icomoon" });
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___, { hash: "#icomoon" });
var ___CSS_LOADER_URL_REPLACEMENT_60___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_61___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_62___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_63___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_64___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___, { hash: "#icomoon" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "icomoon";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
[class^=icon-], [class*=" icon-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icomoon" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-email:before {
  content: "\\e90a";
}

.icon-grid-block:before {
  content: "\\e90c";
}

.icon-info-icon:before {
  content: "\\e90d";
}

.icon-call:before {
  content: "\\e90e";
}

.icon-message:before {
  content: "\\e90f";
}

.icon-back:before {
  content: "\\e917";
}

.icon-notification:before {
  content: "\\e903";
}

.icon-add-user:before {
  content: "\\e904";
}

.icon-dfi-shield:before {
  content: "\\e900";
}

.icon-info:before {
  content: "\\e905";
}

.icon-investment:before {
  content: "\\e906";
}

.icon-listing:before {
  content: "\\e922";
}

.icon-nft:before {
  content: "\\e907";
}

.icon-setting:before {
  content: "\\e908";
}

.icon-wallet:before {
  content: "\\e909";
}

.icon-partner::before {
  content: "\\e910";
}

/* NEWLY ADDED ICONS */
@font-face {
  font-family: "icomoon-new";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
[class^=icon-new-], [class*=" icon-new-"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icomoon-new" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-new-bank::before {
  content: "\\e900";
}

@font-face {
  font-family: "icomoon-chart";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
[class^=icon-line-chart], [class*=" icon-line-chart"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icomoon-chart" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  /* -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; */
}

@font-face {
  font-family: "icomoon-close";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
[class^=icon-close], [class*=" icon-close"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icomoon-close" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-squares:before {
  content: "\\e950";
}

.icon-bar-polar-chart:before {
  content: "\\e953";
}

.icon-line-chart:before {
  content: "\\e951";
}

.icon-polar-area-chart:before {
  content: "\\e954";
}

.icon-bar-and-line-chart:before {
  content: "\\e952";
}

.icon-bar-chart:before {
  content: "\\e955";
}

.icon-close:before {
  content: "\\e900";
}

@font-face {
  font-family: "icomoon-help";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
[class^=icon-Vector], [class*=" icon-Vector"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icomoon-help" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-Vector:before {
  content: "\\e935";
  color: #889096;
}

@font-face {
  font-family: "icomoonalert";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_25___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_28___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
[class^=icon-alert], [class*=" icon-alert"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icomoonalert" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-alert:before {
  content: "\\e900";
  padding: 5px 7px;
  display: flex;
  color: #889096;
  box-sizing: border-box;
  cursor: pointer;
}

/* .alert_wrapper:hover .icon-alert:before {

  box-sizing: border-box;
  border-radius: 5px;
  display: flex;
  background: #C7D5E3;
  color: #2267A4 !important;
  justify-content: center;
  align-items: center;
} */
.alert_wrapper:hover .icon-alert:not(.alertIconClicked):before {
  box-sizing: border-box;
  border-radius: 5px;
  display: flex;
  background: #C7D5E3;
  color: #2267A4 !important;
  justify-content: center;
  align-items: center;
}

.alert-popup::before {
  color: #2267A4 !important;
  padding: 0;
}

.alert_staking_wrapper {
  display: flex;
  width: 100px;
  font-family: Assistant;
  font-weight: 400;
  font-style: Regular;
  font-size: 14px;
  text-transform: uppercase;
  background-color: rgba(34, 103, 164, 0.2);
  border-radius: 4px;
  margin-left: 10px;
  cursor: pointer;
}

.alert_staking_wrapper span {
  padding-left: 0;
}

.alert_staking_wrapper i::before {
  color: #2267A4 !important;
}

@font-face {
  font-family: "icomoon-export";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_30___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_34___}) format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
[class^=icon-export], [class*=" icon-export"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icomoon-export" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-export:before {
  content: "\\e900";
  color: #214175;
}

.icon-export:hover:before {
  content: "\\e900";
  color: #214175;
}

@font-face {
  font-family: "icomoon-customize";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_35___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_36___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_37___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_38___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_39___}) format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
[class^=icon-customize], [class*=" icon-customize"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icomoon-customize" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-customize:before {
  content: "\\e900";
  color: #fff;
}

@font-face {
  font-family: "icomoon_bar";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_40___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_41___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_42___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_43___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_44___}) format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
[class^=icon-bar], [class*=" icon-bar"], [class*=icon--884] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icomoon_bar" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-customize:before {
  content: "\\e900";
  color: #214175;
}

.icon--884:before {
  content: "\\e901";
  color: #2267a4;
  font-size: 11px;
}

@font-face {
  font-family: "icomoon-double";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_46___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_47___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_48___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_49___}) format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
[class^=icon-double-arrow], [class*=icon-double-arrow] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icomoon-double" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-double-arrow:before {
  content: "\\e900";
  color: #2267a4;
  font-size: 11px;
}

@font-face {
  font-family: "icomoon-staking-risk";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_51___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_52___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_53___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_54___}) format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
[class^=icon-stakingRisk], [class*=" icon-stakingRisk"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icomoon-staking-risk" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  color: #7E92A3;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.nav__link.active .icon-stakingRisk {
  color: #2267a4;
}

.icon-stakingRisk:hover {
  color: #2267a4;
}

.icon-stakingRisk:before {
  content: "\\e900";
}

@font-face {
  font-family: "icomoon_infoField";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_55___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_56___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_57___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_58___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_59___}) format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
[class^=icon-Component-2], [class*=" icon-Component-2"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icomoon_infoField" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  font-size: 32px;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  cursor: pointer;
}

.icon-Component-2 .path1:before {
  content: "\\e900";
  color: rgb(33, 65, 117);
  cursor: pointer;
}

.icon-Component-2 .path2:before {
  content: "\\e901";
  margin-left: -1em;
  color: rgb(255, 255, 255);
}

.vector-circle {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  /* adjust */
  height: 33px;
  /* adjust */
  border-radius: 50%;
  border: 2px solid #214175;
  /* circle color */
  background: #fff;
  /* optional */
  cursor: pointer;
}

.vector-circle > .icon-Vector::before {
  color: #214175;
}

@font-face {
  font-family: "icomoon-statistics";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_60___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_61___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_62___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_63___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_64___}) format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: block;
}
[class^=icon-statistics], [class*=" icon-statistics"] {
  /* use !important to prevent issues with browser extensions that change fonts */
  font-family: "icomoon-statistics" !important;
  speak: never;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  /* Better Font Rendering =========== */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.icon-statistics:before {
  content: "\\e900";
  color: #fff;
}`, "",{"version":3,"sources":["webpack://./src/Assets/icomoon/style.css"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,4CAAA;EACA,mPAAA;EAIA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAFF;AAKA;EACE,+EAAA;EACA,iCAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA,mCAAA;EACA,kCAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAQA,sBAAA;AACA;EACE,0BAAA;EACA,4CAAA;EACA,mPAAA;EAIA,mBAAA;EACA,kBAAA;EACA,mBAAA;AARF;AAWA;EACE,+EAAA;EACA,qCAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA,mCAAA;EACA,kCAAA;AAVF;;AAaA;EACE,gBAAA;AAVF;;AAaA;EACE,4BAAA;EACA,6CAAA;EACA,uPAAA;EAIA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAbF;AAgBA;EACE,+EAAA;EACA,uCAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA;uCAAA;AAdF;;AAkBA;EACE,4BAAA;EACA,6CAAA;EACA,uPAAA;EAIA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAlBF;AAqBA;EACE,+EAAA;EACA,uCAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA,mCAAA;EACA,kCAAA;AApBF;;AAuBA;EACE,gBAAA;AApBF;;AAuBA;EACE,gBAAA;AApBF;;AAuBA;EACE,gBAAA;AApBF;;AAuBA;EACE,gBAAA;AApBF;;AAuBA;EACE,gBAAA;AApBF;;AAuBA;EACE,gBAAA;AApBF;;AAuBA;EACE,gBAAA;AApBF;;AAwBA;EACE,2BAAA;EACA,6CAAA;EACA,uPAAA;EAIA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAxBF;AA2BA;EACE,+EAAA;EACA,sCAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA,mCAAA;EACA,kCAAA;AA1BF;;AA6BA;EACE,gBAAA;EACA,cAAA;AA1BF;;AA6BA;EACE,2BAAA;EACA,6CAAA;EACA,uPAAA;EAIA,mBAAA;EACA,kBAAA;EACA,mBAAA;AA7BF;AAgCA;EACE,+EAAA;EACA,sCAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA,mCAAA;EACA,kCAAA;AA/BF;;AAkCA;EACE,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,eAAA;AA/BF;;AAmCA;;;;;;;;;GAAA;AAWA;EACE,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,uBAAA;EACA,mBAAA;AAjCF;;AAoCA;EACE,yBAAA;EACA,UAAA;AAjCF;;AAoCA;EACE,aAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,yCAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;AAjCF;;AAoCA;EACE,eAAA;AAjCF;;AAoCA;EACE,yBAAA;AAjCF;;AAoCA;EACE,6BAAA;EACA,6CAAA;EACA,uPAAA;EAIA,mBAAA;EACA,kBAAA;EACA,mBAAA;AApCF;AAuCA;EACE,+EAAA;EACA,wCAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA,mCAAA;EACA,kCAAA;AAtCF;;AAyCA;EACE,gBAAA;EACA,cAAA;AAtCF;;AAyCA;EACE,gBAAA;EACA,cAAA;AAtCF;;AA2CA;EACE,gCAAA;EACA,6CAAA;EACA,uPAAA;EAIA,mBAAA;EACA,kBAAA;EACA,mBAAA;AA3CF;AA8CA;EACE,+EAAA;EACA,2CAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA,mCAAA;EACA,kCAAA;AA7CF;;AAgDA;EACE,gBAAA;EACA,WAAA;AA7CF;;AAiDA;EACE,0BAAA;EACA,6CAAA;EACA,uPAAA;EAIA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAjDF;AAoDA;EACE,+EAAA;EACA,qCAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA,mCAAA;EACA,kCAAA;AAnDF;;AAsDA;EACE,gBAAA;EACA,cAAA;AAnDF;;AAsDA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AAnDF;;AAsDA;EACE,6BAAA;EACA,6CAAA;EACA,uPAAA;EAIA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAtDF;AAyDA;EACE,+EAAA;EACA,wCAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA,mCAAA;EACA,kCAAA;AAxDF;;AA2DA;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AAxDF;;AA4DA;EACE,mCAAA;EACA,6CAAA;EACA,uPAAA;EAIA,mBAAA;EACA,kBAAA;EACA,mBAAA;AA5DF;AA+DA;EACE,+EAAA;EACA,8CAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,cAAA;EAGA,sCAAA;EACA,mCAAA;EACA,kCAAA;AA/DF;;AAkEA;EACE,cAAA;AA/DF;;AAkEA;EACE,cAAA;AA/DF;;AAkEA;EACE,gBAAA;AA/DF;;AAoEA;EACE,gCAAA;EACA,6CAAA;EACA,uPAAA;EAIA,mBAAA;EACA,kBAAA;EACA,mBAAA;AApEF;AAuEA;EACE,+EAAA;EACA,2CAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,sCAAA;EACA,mCAAA;EACA,kCAAA;EACA,eAAA;AArEF;;AAwEA;EACE,gBAAA;EACA,uBAAA;EACA,eAAA;AArEF;;AAwEA;EACE,gBAAA;EACA,iBAAA;EACA,yBAAA;AArEF;;AAwEA;EACE,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;AArEF;;AAwEA;EACE,cAAA;AArEF;;AAwEA;EACE,iCAAA;EACA,6CAAA;EACA,uPAAA;EAIA,mBAAA;EACA,kBAAA;EACA,mBAAA;AAxEF;AA2EA;EACE,+EAAA;EACA,4CAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,oBAAA;EACA,cAAA;EAEA,sCAAA;EACA,mCAAA;EACA,kCAAA;AA1EF;;AA6EA;EACE,gBAAA;EACA,WAAA;AA1EF","sourcesContent":["@font-face {\n  font-family: 'icomoon';\n  src: url('fonts/icomoon.eot?o38exq');\n  src: url('fonts/icomoon.eot?o38exq#iefix') format('embedded-opentype'),\n    url('fonts/icomoon.ttf?o38exq') format('truetype'),\n    url('fonts/icomoon.woff?o38exq') format('woff'),\n    url('fonts/icomoon.svg?o38exq#icomoon') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon-\"], [class*=\" icon-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoon' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-email:before {\n  content: \"\\e90a\";\n}\n\n.icon-grid-block:before {\n  content: \"\\e90c\";\n}\n\n.icon-info-icon:before {\n  content: \"\\e90d\";\n}\n\n.icon-call:before {\n  content: \"\\e90e\";\n}\n\n.icon-message:before {\n  content: \"\\e90f\";\n}\n\n.icon-back:before {\n  content: \"\\e917\";\n}\n\n.icon-notification:before {\n  content: \"\\e903\";\n}\n\n.icon-add-user:before {\n  content: \"\\e904\";\n}\n\n.icon-dfi-shield:before {\n  content: \"\\e900\";\n}\n\n.icon-info:before {\n  content: \"\\e905\";\n}\n\n.icon-investment:before {\n  content: \"\\e906\";\n}\n\n.icon-listing:before {\n  content: \"\\e922\";\n}\n\n.icon-nft:before {\n  content: \"\\e907\";\n}\n\n.icon-setting:before {\n  content: \"\\e908\";\n}\n\n.icon-wallet:before {\n  content: \"\\e909\";\n}\n\n.icon-partner::before {\n  content: \"\\e910\";\n}\n\n\n/* NEWLY ADDED ICONS */\n@font-face {\n  font-family: 'icomoon-new';\n  src: url('fonts/new-icons/icomoon-new.eot?qk2crm');\n  src: url('fonts/new-icons/icomoon-new.eot?qk2crm#iefix') format('embedded-opentype'),\n    url('fonts/new-icons/icomoon-new.ttf?qk2crm') format('truetype'),\n    url('fonts/new-icons/icomoon-new.woff?qk2crm') format('woff'),\n    url('fonts/new-icons/icomoon-new.svg?qk2crm#icomoon') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon-new-\"], [class*=\" icon-new-\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoon-new' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-new-bank::before {\n  content: \"\\e900\";\n}\n\n@font-face {\n  font-family: 'icomoon-chart';\n  src: url('fonts/chart-icons/icomoon.eot?hqjcbq');\n  src: url('fonts/chart-icons/icomoon.eot?hqjcbq#iefix') format('embedded-opentype'),\n    url('fonts/chart-icons/icomoon.ttf?hqjcbq') format('truetype'),\n    url('fonts/chart-icons/icomoon.woff?hqjcbq') format('woff'),\n    url('fonts/chart-icons/icomoon.svg?hqjcbq#icomoon') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon-line-chart\"], [class*=\" icon-line-chart\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoon-chart' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  /* -webkit-font-smoothing: antialiased;\n-moz-osx-font-smoothing: grayscale; */\n}\n\n@font-face {\n  font-family: 'icomoon-close';\n  src: url('fonts/close-icons/icomoon.eot?7x7j5y');\n  src: url('fonts/close-icons/icomoon.eot?7x7j5y#iefix') format('embedded-opentype'),\n    url('fonts/close-icons/icomoon.ttf?7x7j5y') format('truetype'),\n    url('fonts/close-icons/icomoon.woff?7x7j5y') format('woff'),\n    url('fonts/close-icons/icomoon.svg?7x7j5y#icomoon') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon-close\"], [class*=\" icon-close\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoon-close' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-squares:before {\n  content: \"\\e950\";\n}\n\n.icon-bar-polar-chart:before {\n  content: \"\\e953\";\n}\n\n.icon-line-chart:before {\n  content: \"\\e951\";\n}\n\n.icon-polar-area-chart:before {\n  content: \"\\e954\";\n}\n\n.icon-bar-and-line-chart:before {\n  content: \"\\e952\";\n}\n\n.icon-bar-chart:before {\n  content: \"\\e955\";\n}\n\n.icon-close:before {\n  content: \"\\e900\";\n}\n\n\n@font-face {\n  font-family: 'icomoon-help';\n  src: url('fonts/help-icons/icomoon.eot?la35ux');\n  src: url('fonts/help-icons/icomoon.eot?la35ux#iefix') format('embedded-opentype'),\n    url('fonts/help-icons/icomoon.ttf?la35ux') format('truetype'),\n    url('fonts/help-icons/icomoon.woff?la35ux') format('woff'),\n    url('fonts/help-icons/icomoon.svg?la35ux#icomoon') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon-Vector\"], [class*=\" icon-Vector\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoon-help' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-Vector:before {\n  content: \"\\e935\";\n  color: #889096;\n}\n\n@font-face {\n  font-family: 'icomoonalert';\n  src: url('fonts/alert-icons/icomoon.eot?98yb9f');\n  src: url('fonts/alert-icons/icomoon.eot?98yb9f#iefix') format('embedded-opentype'),\n    url('fonts/alert-icons/icomoon.ttf?98yb9f') format('truetype'),\n    url('fonts/alert-icons/icomoon.woff?98yb9f') format('woff'),\n    url('fonts/alert-icons/icomoon.svg?98yb9f#icomoon') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon-alert\"], [class*=\" icon-alert\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoonalert' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-alert:before {\n  content: \"\\e900\";\n  padding: 5px 7px;\n  display: flex;\n  color: #889096;\n  box-sizing: border-box;\n  cursor: pointer;\n}\n\n\n/* .alert_wrapper:hover .icon-alert:before {\n\n  box-sizing: border-box;\n  border-radius: 5px;\n  display: flex;\n  background: #C7D5E3;\n  color: #2267A4 !important;\n  justify-content: center;\n  align-items: center;\n} */\n\n.alert_wrapper:hover .icon-alert:not(.alertIconClicked):before {\n  box-sizing: border-box;\n  border-radius: 5px;\n  display: flex;\n  background: #C7D5E3;\n  color: #2267A4 !important;\n  justify-content: center;\n  align-items: center;\n}\n\n.alert-popup::before {\n  color: #2267A4 !important;\n  padding: 0;\n}\n\n.alert_staking_wrapper {\n  display: flex;\n  width: 100px;\n  font-family: Assistant;\n  font-weight: 400;\n  font-style: Regular;\n  font-size: 14px;\n  text-transform: uppercase;\n  background-color: #2267A433;\n  border-radius: 4px;\n  margin-left: 10px;\n  cursor: pointer;\n}\n\n.alert_staking_wrapper span {\n  padding-left: 0;\n}\n\n.alert_staking_wrapper i::before {\n  color: #2267A4 !important;\n}\n\n@font-face {\n  font-family: 'icomoon-export';\n  src: url('fonts/export-icons/icomoon.eot?dbdzzi');\n  src: url('fonts/export-icons/icomoon.eot?dbdzzi#iefix') format('embedded-opentype'),\n    url('fonts/export-icons/icomoon.ttf?dbdzzi') format('truetype'),\n    url('fonts/export-icons/icomoon.woff?dbdzzi') format('woff'),\n    url('fonts/export-icons/icomoon.svg?dbdzzi#icomoon') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon-export\"], [class*=\" icon-export\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoon-export' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-export:before {\n  content: \"\\e900\";\n  color: #214175;\n}\n\n.icon-export:hover:before {\n  content: \"\\e900\";\n  color: #214175;\n}\n\n\n\n@font-face {\n  font-family: 'icomoon-customize';\n  src: url('fonts/customize-icons/icomoon.eot?h20uxn');\n  src: url('fonts/customize-icons/icomoon.eot?h20uxn#iefix') format('embedded-opentype'),\n    url('fonts/customize-icons/icomoon.ttf?h20uxn') format('truetype'),\n    url('fonts/customize-icons/icomoon.woff?h20uxn') format('woff'),\n    url('fonts/customize-icons/icomoon.svg?h20uxn#icomoon') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon-customize\"], [class*=\" icon-customize\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoon-customize' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-customize:before {\n  content: \"\\e900\";\n  color: #fff;\n}\n\n\n@font-face {\n  font-family: 'icomoon_bar';\n  src: url('fonts/bar-icons/icomoon.eot?3qba93');\n  src: url('fonts/bar-icons/icomoon.eot?3qba93#iefix') format('embedded-opentype'),\n    url('fonts/bar-icons/icomoon.ttf?3qba93') format('truetype'),\n    url('fonts/bar-icons/icomoon.woff?3qba93') format('woff'),\n    url('fonts/bar-icons/icomoon.svg?3qba93#icomoon') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon-bar\"], [class*=\" icon-bar\"], [class*=\"icon--884\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoon_bar' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-customize:before {\n  content: \"\\e900\";\n  color: #214175;\n}\n\n.icon--884:before {\n  content: \"\\e901\";\n  color: #2267a4;\n  font-size: 11px;\n}\n\n@font-face {\n  font-family: 'icomoon-double';\n  src: url('fonts/double-arrow-icons/icomoon.eot?7lkkx');\n  src: url('fonts/double-arrow-icons/icomoon.eot?7lkkx#iefix') format('embedded-opentype'),\n    url('fonts/double-arrow-icons/icomoon.ttf?7lkkx') format('truetype'),\n    url('fonts/double-arrow-icons/icomoon.woff?7lkkx') format('woff'),\n    url('fonts/double-arrow-icons/icomoon.svg?7lkkx#icomoon') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon-double-arrow\"], [class*=\"icon-double-arrow\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoon-double' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-double-arrow:before {\n  content: \"\\e900\";\n  color: #2267a4;\n  font-size: 11px;\n}\n\n\n@font-face {\n  font-family: 'icomoon-staking-risk';\n  src: url('fonts/staking-risk/icomoon.eot?tcjqyc');\n  src: url('fonts/staking-risk/icomoon.eot?tcjqyc#iefix') format('embedded-opentype'),\n    url('fonts/staking-risk/icomoon.ttf?tcjqyc') format('truetype'),\n    url('fonts/staking-risk/icomoon.woff?tcjqyc') format('woff'),\n    url('fonts/staking-risk/icomoon.svg?tcjqyc#icomoon') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon-stakingRisk\"], [class*=\" icon-stakingRisk\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoon-staking-risk' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  color: #7E92A3;\n\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.nav__link.active .icon-stakingRisk {\n  color: #2267a4;\n}\n\n.icon-stakingRisk:hover {\n  color: #2267a4;\n}\n\n.icon-stakingRisk:before {\n  content: \"\\e900\";\n}\n\n\n\n@font-face {\n  font-family: 'icomoon_infoField';\n  src: url('fonts/infoField/icomoon.eot?pvfjwx');\n  src: url('fonts/infoField/icomoon.eot?pvfjwx#iefix') format('embedded-opentype'),\n    url('fonts/infoField/icomoon.ttf?pvfjwx') format('truetype'),\n    url('fonts/infoField/icomoon.woff?pvfjwx') format('woff'),\n    url('fonts/infoField/icomoon.svg?pvfjwx#icomoon') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon-Component-2\"], [class*=\" icon-Component-2\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoon_infoField' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  font-size: 32px;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  cursor: pointer;\n}\n\n.icon-Component-2 .path1:before {\n  content: \"\\e900\";\n  color: rgb(33, 65, 117);\n  cursor: pointer;\n}\n\n.icon-Component-2 .path2:before {\n  content: \"\\e901\";\n  margin-left: -1em;\n  color: rgb(255, 255, 255);\n}\n\n.vector-circle {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  /* adjust */\n  height: 33px;\n  /* adjust */\n  border-radius: 50%;\n  border: 2px solid #214175;\n  /* circle color */\n  background: #fff;\n  /* optional */\n  cursor: pointer;\n}\n\n.vector-circle>.icon-Vector::before {\n  color: #214175;\n}\n\n@font-face {\n  font-family: 'icomoon-statistics';\n  src: url('fonts/statistics-icons/icomoon.eot?myhb3s');\n  src: url('fonts/statistics-icons/icomoon.eot?myhb3s#iefix') format('embedded-opentype'),\n    url('fonts/statistics-icons/icomoon.ttf?myhb3s') format('truetype'),\n    url('fonts/statistics-icons/icomoon.woff?myhb3s') format('woff'),\n    url('fonts/statistics-icons/icomoon.svg?myhb3s#icomoon') format('svg');\n  font-weight: normal;\n  font-style: normal;\n  font-display: block;\n}\n\n[class^=\"icon-statistics\"], [class*=\" icon-statistics\"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'icomoon-statistics' !important;\n  speak: never;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.icon-statistics:before {\n  content: \"\\e900\";\n  color: #fff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
